export default class BurgerButton {
  constructor() {
    this.menuTrigger = document.getElementById('menu-trigger');
    this.line1 = this.menuTrigger.querySelector('.line-1');
    this.line2 = this.menuTrigger.querySelector('.line-2');
    this.circle = this.menuTrigger.querySelector('.circle');
    this.body = document.body;
    this.isWorking = false;
    this.init();
    this.events();
  }

  init() {}

  onButtonClicked(ev) {
    if (this.isWorking) return true;
    this.isWorking = true;
    
    if (!this.body.classList.contains('main-menu-open')) {
      this.body.classList.add('main-menu-open');
      window.dispatchEvent(new Event('mainMenu.open'));
      // gsap.to(circle, {duration: 1, scale: 0.8, top: '50%', left: '50%', xPercent: '-50', yPercent: '-50' })
    } else {
      window.dispatchEvent(new Event('mainMenu.close'));
      this.body.classList.remove('main-menu-open');
      // gsap.to(circle, {duration: 1, scale: 1, top: '6px', left: '2px', xPercent: 0, yPercent: 0, scale: 1 })
    }

    setTimeout(() => {
      this.isWorking = false;
    }, 1000)

  }

  onStickyHeaderShow(ev) {
    // console.log(ev);
  }

  onStickyHeaderHide(ev) {
    // console.log(ev);
  }

  events() {
    this.menuTrigger.addEventListener('click', this.onButtonClicked.bind(this));
    window.addEventListener('stickyHeader.show', this.onStickyHeaderShow.bind(this));
    window.addEventListener('stickyHeader.hide', this.onStickyHeaderHide.bind(this));
  }
}